import { motion } from "framer-motion";
import { MapPin, Navigation, Clock } from "lucide-react";

const MAP_LINK = "https://maps.app.goo.gl/jtiQYyXCUxTrsHDfA?g_st=ic";
const MAP_QUERY = encodeURIComponent("منتزه الميريلاند تاجوراء البيفي ليبيا");
const EMBED_URL = `https://maps.google.com/maps?q=${MAP_QUERY}&hl=ar&z=15&output=embed`;

export default function Location() {
  return (
    <section id="location" className="relative py-24 sm:py-32 bg-white" data-testid="location-section">
      <div className="container-x">
        <div className="max-w-2xl mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#10B981]/10 text-[#10B981] text-xs font-black mb-3">
            <MapPin className="w-3.5 h-3.5" />
            موقع المهرجان
          </div>
          <h2 className="font-display text-3xl sm:text-5xl font-black text-[#1E293B]" data-testid="location-title">
            كيف تصل إلينا؟
          </h2>
          <p className="mt-3 text-[#475569] font-semibold">
            المهرجان يقام في <span className="text-[#0066CC] font-black">منتزه الميريلاند</span> — تاجوراء، منطقة البيفي.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6 items-stretch">
          {/* Map */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-2 relative rounded-3xl overflow-hidden border-4 border-[#FFD600] shadow-[0_20px_50px_rgba(0,102,204,.15)]"
            data-testid="location-map"
          >
            <iframe
              title="خريطة موقع منتزه الميريلاند"
              src={EMBED_URL}
              className="w-full h-[420px] sm:h-[500px] block"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
            {/* Overlay CTA */}
            <a
              href={MAP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="absolute bottom-4 left-4 inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-white shadow-lg text-[#0066CC] font-black text-sm hover:bg-[#FFD600] hover:text-[#1E293B] transition-colors"
              data-testid="open-in-maps"
            >
              <Navigation className="w-4 h-4" />
              فتح في خرائط Google
            </a>
          </motion.div>

          {/* Info cards */}
          <div className="flex flex-col gap-5">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="playful-card"
            >
              <div className="w-12 h-12 rounded-2xl bg-[#E63946] text-white flex items-center justify-center mb-4">
                <MapPin className="w-6 h-6" />
              </div>
              <h3 className="font-display text-lg font-black text-[#1E293B]">العنوان</h3>
              <p className="text-sm text-[#475569] font-semibold mt-1 leading-relaxed">
                منتزه الميريلاند<br />
                تاجوراء — البيفي، طرابلس، ليبيا
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="playful-card"
            >
              <div className="w-12 h-12 rounded-2xl bg-[#0066CC] text-white flex items-center justify-center mb-4">
                <Clock className="w-6 h-6" />
              </div>
              <h3 className="font-display text-lg font-black text-[#1E293B]">مواعيد الفعاليات</h3>
              <p className="text-sm text-[#475569] font-semibold mt-1 leading-relaxed">
                17 • 18 • 19 سبتمبر<br />
                يوميًا من 05:00 مساءً حتى 08:00 مساءً
              </p>
            </motion.div>

            <a
              href={MAP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-3d w-full justify-center"
              data-testid="get-directions"
            >
              <Navigation className="w-5 h-5" />
              احصل على الاتجاهات
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
